import React from 'react';
import { Button } from 'react-bootstrap';

const SlotsSuccessModal = ({
    showSlotsSuccessModal,
    setShowSlotsSuccessModal,
    setSelectedOfferForSlots,
    setDuplicateOffers,
    history
}) => {
    if (!showSlotsSuccessModal) return null;

    return (
        <div style={{
            position: 'fixed',
            top: 0,
            left: 0,
            width: '100%',
            height: '100%',
            backgroundColor: 'rgba(0,0,0,0.5)',
            display: 'flex',
            justifyContent: 'center',
            alignItems: 'center',
            zIndex: 1000
        }}>
            <div style={{
                backgroundColor: 'white',
                padding: '30px',
                borderRadius: '8px',
                maxWidth: '400px',
                width: '90%',
                textAlign: 'center'
            }}>
                <h3 style={{color: '#68BB5F', marginBottom: '20px'}}>Success!</h3>
                <p style={{marginBottom: '30px', fontSize: '16px'}}>
                    Slots updated successfully!
                </p>
                <div style={{display: 'flex', justifyContent: 'center', gap: '15px'}}>
                    <Button 
                        onClick={() => {
                            setShowSlotsSuccessModal(false);
                            setSelectedOfferForSlots(null);
                            setDuplicateOffers([]);
                        }}
                        className="button-regular"
                        style={{backgroundColor: '#6c757d', borderColor: '#6c757d'}}
                    >
                        Close
                    </Button>
                    <Button 
                        onClick={() => {
                            history.push('/vtoAdminRequests');
                        }}
                        className="button-regular"
                        style={{backgroundColor: '#0078d2', borderColor: '#0078d2'}}
                    >
                        My Offers
                    </Button>
                </div>
            </div>
        </div>
    );
};

export default SlotsSuccessModal;
